// extracted by mini-css-extract-plugin
export default {"popup":"PopUp_popup__bkQEs","active":"PopUp_active__sZFv9"};